export default {
  "app": {
    "name": "DeepTrade",
    "tagline": "KI-gestützter Kryptowährungshandel",
    "description": "Erweiterte Handelssignale und automatisiertes Portfolio-Management",
  },
  "navigation": {
    "dashboard": "Dashboard",
    "trading": "Handel",
    "signals": "Signale",
    "apiCredentials": "API-Anmeldedaten",
    "autoTrading": "Automatischer Handel",
    "tierManagement": "Stufen-Verwaltung",
    "referrals": "Empfehlungen",
    "accessSecurity": "Zugang & Sicherheit",
    "settings": "Einstellungen",
    "help": "Hilfe & Support",
    "login": "Anmelden",
    "register": "Registrieren",
    "logout": "Abmelden",
    "home": "Startseite",
  },
  "auth": {
    "layout": {
      "signInToAccount": "Melden Sie sich bei Ihrem Konto an",
      "or": "Oder",
      "createNewAccount": "ein neues Konto erstellen"
    },
    "login": {
      "title": "Willkommen zurück",
      "subtitle": "Geben Sie Ihre E-Mail und Ihr Passwort ein, um sich anzumelden",
      "email": "E-Mail",
      "password": "Passwort",
      "emailPlaceholder": "name@example.com",
      "passwordPlaceholder": "••••••••",
      "rememberMe": "Angemeldet bleiben",
      "forgotPassword": "Passwort vergessen?",
      "signIn": "Anmelden",
      "noAccount": "Noch kein Konto?",
      "signUp": "Registrieren",
      "googleSignIn": "Mit Google fortfahren",
      "orContinueWith": "Oder fortfahren mit",
      "fillAllFields": "Bitte füllen Sie alle Felder aus",
      "loginSuccess": "Anmeldung erfolgreich!",
      "loginFailed": "Anmeldung fehlgeschlagen",
      "loginFailedDescription": "Anmeldung fehlgeschlagen",
      "googleLoginFailed": "Google-Anmeldung konnte nicht gestartet werden",
      "bySigningIn": "Durch die Anmeldung stimmen Sie unseren",
      "termsOfService": "Nutzungsbedingungen",
      "privacyPolicy": "Datenschutzrichtlinie",
      "and": "und"
    },
    "register": {
      "title": "Konto erstellen",
      "subtitle": "Geben Sie Ihre Informationen ein, um ein Konto zu erstellen",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail",
      "password": "Passwort",
      "confirmPassword": "Passwort bestätigen",
      "agreeTerms": "Durch Klicken auf Fortfahren stimmen Sie unseren",
      "createAccount": "Konto erstellen",
      "hasAccount": "Haben Sie bereits ein Konto?",
      "signIn": "Anmelden",
      "orContinueWith": "Oder fortfahren mit",
      "googleSignUp": "Mit Google registrieren",
      "termsOfService": "Nutzungsbedingungen",
      "privacyPolicy": "Datenschutzrichtlinie",
      "referralCode": "Empfehlungscode (Optional)",
      "placeholders": {
        "firstName": "Max",
        "lastName": "Mustermann",
        "email": "name@beispiel.com",
        "password": "Passwort eingeben",
        "confirmPassword": "Passwort bestätigen",
        "referralCode": "Empfehlungscode eingeben"
      },
      "validation": {
        "minLength": "Das Passwort muss mindestens 8 Zeichen lang sein",
        "uppercase": "Das Passwort muss mindestens einen Großbuchstaben enthalten",
        "lowercase": "Das Passwort muss mindestens einen Kleinbuchstaben enthalten",
        "number": "Das Passwort muss mindestens eine Zahl enthalten",
        "specialChar": "Das Passwort muss mindestens ein Sonderzeichen enthalten"
      },
      "errors": {
        "invalidReferralCode": "Ungültiger Empfehlungscode",
        "referralValidationFailed": "Empfehlungscode konnte nicht validiert werden. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
        "googleLoginFailed": "Google-Anmeldung fehlgeschlagen",
        "googleLoginFailedTitle": "Google-Anmeldung fehlgeschlagen",
        "fillAllFields": "Bitte füllen Sie alle Felder aus",
        "requirementsNotMet": "Passwort-Anforderungen nicht erfüllt",
        "passwordsDoNotMatch": "Passwörter stimmen nicht überein",
        "registrationFailed": "Registrierung fehlgeschlagen",
        "failedToCreateAccount": "Konto konnte nicht erstellt werden",
        "emailAlreadyRegistered": "E-Mail bereits registriert",
        "emailAlreadyRegisteredDescription": "Ein Konto mit dieser E-Mail-Adresse existiert bereits. Bitte versuchen Sie sich anzumelden.",
        "connectionError": "Verbindungsfehler",
        "connectionErrorDescription": "Verbindung zum Server fehlgeschlagen. Überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
        "referralCodeError": "Empfehlungscode-Fehler",
        "referralCodeErrorDescription": "Es gab ein Problem bei der Verarbeitung Ihres Empfehlungscodes. Ihr Konto wird trotzdem erstellt.",
        "failedToResendEmail": "Bestätigungs-E-Mail konnte nicht erneut gesendet werden",
        "failedToResendEmailTitle": "E-Mail konnte nicht erneut gesendet werden",
        "tryAgainLater": "Bitte versuchen Sie es später erneut."
      },
      "success": {
        "title": "Registrierung erfolgreich!",
        "description": "Bitte überprüfen Sie Ihre E-Mail, um Ihr Konto zu verifizieren."
      },
      "verification": {
        "title": "Überprüfen Sie Ihre E-Mail",
        "description": "Wir haben einen Bestätigungslink an {{email}} gesendet",
        "nextSteps": "Nächste Schritte:",
        "step1": "1. Überprüfen Sie Ihren Posteingang",
        "step2": "2. Klicken Sie auf den Bestätigungslink",
        "step3": "3. Kehren Sie hierher zurück, um sich anzumelden",
        "sending": "Wird gesendet...",
        "resendButton": "Bestätigungs-E-Mail erneut senden",
        "backToLogin": "Zurück zur Anmeldung",
        "emailSentTitle": "Bestätigungs-E-Mail gesendet",
        "emailSentDescription": "Bitte überprüfen Sie Ihre E-Mail für den Bestätigungslink."
      },
      "referral": {
        "validating": "Empfehlungscode wird validiert...",
        "validCode": "Gültiger Empfehlungscode von {{referrer}}"
      }
    },
    "passwordRequirements": {
      "title": "Passwort-Anforderungen",
      "length": "Mindestens 8 Zeichen",
      "uppercase": "Ein Großbuchstabe",
      "lowercase": "Ein Kleinbuchstabe",
      "number": "Eine Zahl",
      "special": "Ein Sonderzeichen",
    },
    "errors": {
      "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      "emailRequired": "E-Mail ist erforderlich",
      "invalidCredentials": "Ungültige E-Mail oder Passwort",
      "passwordRequired": "Passwort ist erforderlich",
      "passwordTooShort": "Passwort muss mindestens 8 Zeichen haben",
      "passwordsNotMatch": "Passwörter stimmen nicht überein",
      "termsRequired": "Sie müssen den Geschäftsbedingungen zustimmen",
    }
  },
  "dashboard": {
    "title": "Dashboard",
    "welcome": "Willkommen zurück!",
    "overview": "Übersicht",
    "trading": "Handel",
    "tier": "Stufe",
    "balance": "Guthaben",
    "pnlToday": "Gewinn und Verlust",
    "totalTrades": "Gesamte Trades",
    "winRate": "Gewinnrate",
    "activeSignals": "Aktive Signale",
    "tradingOverview": "Handelsübersicht",
    "quickActions": "Schnellaktionen",
    "viewSignals": "Signale anzeigen",
    "autoTrading": "Automatischer Handel",
    "autoTradingDescription": "Handelssignale automatisch ausführen",
    "currentTier": "Aktuelle Stufe",
    "progressTo": "Fortschritt zu Stufe {{tier},",
    "yourBenefits": "Ihre Vorteile",
    "advancedSignals": "Erweiterte Handelssignale",
    "autoTradingFeatures": "Auto-Trading-Funktionen",
    "prioritySupport": "Prioritätssupport",
    "monthlyRate": "Monatliche Rate",
    "profitShare40": "40% Gewinnbeteiligung",
    "profitShare20": "20% Gewinnbeteiligung",
    "profitShare10": "10% Gewinnbeteiligung",
    "verifyingNFT": "NFT-Besitz wird überprüft...",
    "debt": "Schulden",
    "btcPrice": {
      "symbol": "BTC/USDT",
      "loading": "BTC/USDT: Lädt...",
      "unavailable": "BTC/USDT: --",
      "connecting": "Verbinde...",
      "live": "Live",
      "error": "Fehler ({{count}})",
      "24h": "24h",
    },
    "controls": {
      "turnOn": "Einschalten",
      "turnOff": "Ausschalten",
      "paperAutoTrading": "Papier-Auto-Trading",
    },
    "forecast": {
      "title": "Preisprognose",
      "refresh": "Aktualisieren",
      "errorLoading": "Fehler beim Laden des Diagramms",
      "retry": "Wiederholen",
      "noData": "Keine Diagrammdaten verfügbar",
    },
    "tradingChart": {
      "forecast": "Prognose",
      "upperBound": "Obere Grenze",
      "lowerBound": "Untere Grenze",
      "support": "Unterstützung",
      "resistance": "Widerstand",
      "entry": "Einstieg",
      "stopLoss": "Stop-Loss",
      "takeProfit": "Take-Profit",
      "partialTakeProfit": "Teilgewinnmitnahme",
      "liquidation": "Liquidation",
      "locked": "Gesperrt",
      "positionLevelDialogTitle": "Aktualisierung von {{level}} bestätigen",
      "positionLevelDialogDescription": "{{level}} für {{symbol}} {{side}} von {{currentPrice}} auf {{newPrice}} setzen?",
      "positionLevelDelta": "Änderung: {{delta}} %",
      "positionLevelConfirm": "{{level}} aktualisieren",
      "positionLevelCancel": "Abbrechen",
      "positionLevelProcessing": "Wird aktualisiert...",
      "positionLevelSuccess": "{{level}} aktualisiert",
      "positionLevelSuccessDesc": "{{symbol}} {{side}} · neues {{level}}: {{price}}",
      "positionLevelFailure": "Aktualisierung von {{level}} fehlgeschlagen",
      "positionLevelFailureDesc": "Das vorherige Niveau wurde wiederhergestellt. {{error}}",
      "dragHint": "Ziehen zum Verschieben · loslassen zum Bestätigen",
      "indicators": {
        "title": "Indikatoren",
        "overlays": "Overlays",
        "panes": "Panels",
        "levels": "Level",
        "keyLevels": "Kurslevel (S/R)",
        "reset": "Indikatoren zurücksetzen",
        "ema20": "EMA 20",
        "ema50": "EMA 50",
        "ema200": "EMA 200",
        "sma20": "SMA 20",
        "sma50": "SMA 50",
        "bb20": "Bollinger-Bänder (20, 2)",
        "bbUpper": "Bollinger oben",
        "bbMiddle": "Bollinger Mitte",
        "bbLower": "Bollinger unten",
        "vwap": "VWAP",
        "rsi14": "RSI (14)",
        "macd": "MACD (12, 26, 9)",
        "macdSignal": "MACD-Signal",
      },
      "drawing": {
        "toolbar": "Zeichenwerkzeuge",
        "select": "Auswählen",
        "magnetMode": "Magnet: {{mode}}",
        "stayInDrawingMode": "Zeichenmodus beibehalten",
        "hideAll": "Alle Zeichnungen ausblenden",
        "showAll": "Alle Zeichnungen anzeigen",
        "undo": "Rückgängig",
        "redo": "Wiederholen",
        "deleteSelected": "Ausgewählte Zeichnungen löschen",
        "clearAll": "Alle Zeichnungen löschen",
        "moreTools": "Weitere Zeichenwerkzeuge",
        "export": "Zeichnungen exportieren",
        "import": "Zeichnungen importieren",
        "textPrompt": "Zeichnungstext eingeben",
        "loadFailure": "Zeichenwerkzeuge nicht verfügbar",
        "importEmpty": "Keine Zeichnungen in dieser Datei gefunden",
        "importSuccess": "{{count}} Zeichnungen importiert",
        "importFailure": "Zeichnungen konnten nicht importiert werden",
        "clearConfirmTitle": "Alle Zeichnungen löschen?",
        "clearConfirmDescription": "Dadurch werden alle Zeichnungen für das aktuelle Symbol und den Zeitrahmen entfernt. Dies kann nicht rückgängig gemacht werden.",
        "categories": {
          "lines": "Linien",
          "channels": "Kanäle",
          "fibonacci": "Fibonacci & Gann",
          "patterns": "Muster",
          "elliott": "Elliott",
          "forecasting": "Prognose & Messung",
          "volume": "Volumen",
          "annotations": "Anmerkungen",
          "shapes": "Formen",
          "cycles": "Zyklen",
          "regression": "Regression",
        },
        "tools": {
          "trend-line": "Trendlinie",
          "horizontal-line": "Horizontale Linie",
          "vertical-line": "Vertikale Linie",
          "ray": "Strahl",
          "parallel-channel": "Paralleler Kanal",
          "fib-retracement": "Fib-Retracement",
          "trend-based-fib-extension": "Trendbasierte Fib-Extension",
          "rectangle": "Rechteck",
          "text": "Text",
          "arrow": "Pfeil",
          "brush": "Pinsel",
          "price-range": "Preisbereich",
          "long-position": "Long-Position",
          "short-position": "Short-Position",
        },
      },
    },
    "realTimePerformance": "Leistung in Echtzeit",
    "riskSettings": {
      "title": "Risikomanagement-Einstellungen",
      "paperTradingTitle": "Risikomanagement-Einstellungen - Demo-Handel",
      "loading": "Risikoeinstellungen werden geladen...",
      "investmentPercentage": "Investitionsanteil",
      "investmentDescription": "Prozentsatz des Guthabens für den Handel (0% - 10%)",
      "leverage": "Hebel",
      "leverageDescription": "Max: {{max}}x für Stufe {{tier}} + {{exchange}} {{market},",
      "paperTradingLeverageDesc": "Im Demo-Modus können Sie jede Hebel-Einstellung zu Testzwecken verwenden",
      "exchange": "Börse: ",
      "configureCredentials": "In API-Anmeldedaten konfigurieren",
      "warningZeroInvestment": "Wählen Sie Investitionsanteil > 0%, um den Handel zu aktivieren",
      "paperTradingNote": "Demo-Handel-Modus - keine Stufen-Beschränkungen gelten",
      "saveSettings": "Einstellungen speichern",
      "saving": "Speichern...",
      "resetToSafe": "Auf sicher zurücksetzen",
      "confirmSaveTitle": "Risikoeinstellungen bestätigen",
      "confirmSaveDesc": "Sind Sie sicher, dass Sie diese Risikoeinstellungen speichern möchten?\n\nInvestition: {{investment}}%\nHebel: {{leverage}}x\nModus: {{mode}}",
      "confirmSave": "Einstellungen speichern",
      "saveSuccess": "Einstellungen gespeichert",
      "saveSuccessDesc": "Ihre Risikomanagement-Einstellungen wurden erfolgreich gespeichert.",
      "saveError": "Speichern fehlgeschlagen",
      "tradingStrategy": "Handelsstrategie",
      "strategyActive": "Standard-Strategie",
      "strategyConservative": "Neuronale KI-Strategie",
      "strategyActiveBadge": "Empfohlen",
      "strategyActiveDesc": "Häufigere Trades basierend auf ML-Preisvorhersagen. Generiert 3-8 Signale pro Tag mit 75-80% erwarteter Genauigkeit. Ideal für Trader, die mehr Chancen möchten und moderate Aktivität bewältigen können.",
      "strategyConservativeDesc": "Weniger, aber hochkonfidente Trades mit strengen Bestätigungen. Generiert 1-3 Signale pro Tag mit 85-90% erwarteter Genauigkeit. Ideal für konservative Trader, die Qualität über Quantität stellen.",
      "gridTradingTitle": "Grid Trading",
      "gridEnabledLabel": "Grid Trading aktivieren",
      "trailingStopTitle": "Trailing Stop",
      "trailingStopEnabledLabel": "Trailing Stop aktivieren",
      "signalsPerDay": "Signale pro Tag",
      "expectedAccuracy": "Erwartete Genauigkeit",
      "tradeFrequency": "Trading-Häufigkeit",
      "riskLevel": "Risikoniveau",
      "profitPotential": "Gewinnpotenzial",
      "bestFor": "Am Besten Für",
      "activeTraders": "Aktive Trader, die mehr Gelegenheiten wünschen",
      "conservativeTraders": "Konservative Trader, die Qualität über Quantität bevorzugen",
      "high": "Hoch",
      "low": "Niedrig",
      "moderate": "Moderat",
      "higher": "Höher",
      "viewComparison": "Vergleich Anzeigen",
      "hideComparison": "Vergleich Ausblenden",
      "testForecastStrategy": "Prognosestrategie testen",
      "testingStrategy": "Strategie wird getestet...",
      "testStrategyDesc": "Klicken Sie, um zu testen, ob die Prognosestrategie jetzt einen Trade eröffnen würde",
      "paperSettingsError": "Papier-Einstellungen Fehler",
      "paperSettingsErrorDesc": "Fehler beim Laden der Papier-Trading-Risikoeinstellungen.",
      "settingsLoadError": "Einstellungen Ladefehler",
      "settingsLoadErrorDesc": "Fehler beim Laden der Risikoeinstellungen. Bitte aktualisieren Sie die Seite.",
      "configurationRequired": "Konfiguration erforderlich",
      "configurationRequiredDesc": "Bitte setzen Sie den Investitionsprozentsatz über 0%, bevor Sie die Strategie testen.",
      "noTradeSignal": "Kein Trading-Signal",
      "noTradeSignalDesc": "Prognose zeigt unzureichende Bewegung. Aufwärts: {{upward}}%, Abwärts: {{downward}}%. Benötigt >0,5% um Trading auszulösen.",
      "strategyTestSuccessful": "Strategietest erfolgreich",
      "strategyTestSuccessfulDesc": "{{direction}}-Signal erkannt mit {{movement}}% potentieller Bewegung. {{result}}",
      "paperTradeOpened": "Papier-Trade erfolgreich eröffnet!",
      "tradeSimulationCompleted": "Trade-Simulation abgeschlossen.",
      "strategyTestFailed": "Strategietest fehlgeschlagen",
      "strategyTestFailedDesc": "Unbekannter Fehler während des Strategietests aufgetreten.",
      "strategyTestError": "Strategietest-Fehler",
      "strategyTestErrorDesc": "Fehler beim Testen der Prognose-Strategie.",
    },
    "activePositions": {
      "title": "Aktive Positionen",
      "tabs": {
        "all": "alle",
        "app": "app",
        "external": "extern",
      },
      "refresh": "Aktualisieren",
      "errorLoading": "Fehler beim Laden aktiver Positionen",
      "retry": "Wiederholen",
      "noPositions": "Keine aktiven Positionen.",
      "noPositionsDesc": "Ihre aktiven Trading-Positionen werden hier angezeigt, sobald Sie mit dem Handel beginnen oder Auto-Trading aktivieren.",
      "noAppPositions": "Keine aktiven App-Positionen.",
      "noExternalPositions": "Keine aktiven externen Positionen.",
      "addCredentialsWarning": " API-Anmeldedaten hinzufügen, um externe Positionen zu sehen",
      "externalError": "❌ Externe Positionsfehler: {{error},",
      "externalErrorGeneric": "❌ {{error},",
      "diagnostics": "App: {{app}} | Extern: {{external},",
      "fields": {
        "size": "Größe",
        "entryPrice": "Einstiegspreis",
        "currentPrice": "Aktueller Preis",
        "margin": "Marge",
        "liquidationPrice": "Liquidationspreis",
        "marginRate": "Margenrate",
        "takeProfit": "TP",
        "stopLoss": "SL",
        "roi": "ROE",
        "none": "Keine",
        "na": "N/A",
      },
      "positionTypes": {
        "appPositions": "App-Positionen",
        "externalPositions": "Externe Positionen",
      },
      "headers": {
        "symbol": "Symbol",
        "size": "Größe",
        "entryPrice": "Einstiegspreis",
        "markPrice": "Markpreis",
        "liqPrice": "Liq. Preis",
        "margin": "Marge",
        "pnlRoi": "PNL (ROE %)",
        "tpSl": "TP/SL",
        "actions": "Aktionen",
      },
      "close": "Schließen",
      "closing": "Schließe...",
      "featureNotAvailable": "Funktion nicht verfügbar",
      "positionClosingPaperOnly": "Das Schließen von Positionen ist derzeit nur im Papier-Trading-Modus verfügbar.",
      "tpSlPaperOnly": "TP/SL ist derzeit nur im Papier-Trading-Modus verfügbar.",
      "positionClosed": "Position geschlossen",
      "positionClosedDesc": "Position erfolgreich geschlossen. PnL: ${{pnl}}",
      "errorClosingPosition": "Fehler beim Schließen der Position",
      "errorClosingPositionDesc": "Fehler beim Schließen der Position",
      "takeProfitSet": "Take Profit gesetzt",
      "takeProfitSetDesc": "Take Profit bei ${{price}} gesetzt",
      "errorSettingTakeProfit": "Fehler beim Setzen von Take Profit",
      "errorSettingTakeProfitDesc": "Fehler beim Setzen von Take Profit",
      "stopLossSet": "Stop Loss gesetzt",
      "stopLossSetDesc": "Stop Loss bei ${{price}} gesetzt",
      "errorSettingStopLoss": "Fehler beim Setzen von Stop Loss",
      "errorSettingStopLossDesc": "Fehler beim Setzen von Stop Loss",
      "position": "Position",
      "positions": "Positionen",
      "allPositions": "Alle Positionen",
      "noApiCredentials": "Keine API-Anmeldedaten verbunden",
    },
    "debug": {
      "testSuccessful": "Debug-Trading-Test Erfolgreich",
      "paperTradeOpened": "Papier-Trade erfolgreich eröffnet!",
      "tradeSimulationCompleted": "Trade-Simulation abgeschlossen.",
      "testFailed": "Debug-Trading-Test Fehlgeschlagen",
      "unknownError": "Unbekannter Fehler während des Debug-Trading-Tests aufgetreten.",
      "testError": "Debug-Test-Fehler",
      "testErrorDesc": "Fehler beim Testen der Trade-Eröffnung.",
    },
    "profitShare": {
      "title": "Gewinnbeteiligungs-Tracking",
      "loading": "Gewinnbeteiligungsdaten werden geladen...",
      "noData": "Keine Gewinnbeteiligungsdaten verfügbar. Beginnen Sie mit dem Handel, um Ihre Gewinne zu verfolgen.",
      "balanceOverview": "Guthabenübersicht",
      "initialBalance": "Anfangsguthaben:",
      "currentBalance": "Aktuelles Guthaben:",
      "netDeposits": "Nettoeinzahlungen:",
      "profitAnalysis": "Gewinnanalyse",
      "tradingProfit": "Handelsgewinn:",
      "trueProfit": "Wahrer Gewinn:",
      "profitPercentage": "Gewinn %:",
      "profitShareInfo": "Gewinnbeteiligung",
      "tierRate": "Stufe {{tier}} Rate:",
      "amountOwed": "Geschuldeter Betrag:",
      "status": "Status:",
      "profitable": "Konto ist profitabel - Gewinnbeteiligung gilt für Gewinne über dem Anfangsguthaben",
      "notProfitable": "Konto ist noch nicht profitabel - Keine Gewinnbeteiligung bis das Guthaben Anfangs- + Einzahlungen übersteigt",
      "profitableDescription": "Ihr Guthaben liegt über Ihrem Anfangskapital und den Einzahlungen. Gewinnbeteiligungsgebühren werden auf die oben angezeigten Gewinne berechnet.",
      "notProfitableDescription": "Handeln Sie weiter, bis Sie Ihr Anfangskapital plus Einzahlungen überschreiten. Bis dahin fällt keine Gewinnbeteiligung an.",
      "paymentRequired": "Zahlung erforderlich",
      "paymentDescription": "Sie haben ${{amount}} an Gewinnbeteiligungsgebühren zu zahlen.",
      "payNow": "Jetzt zahlen",
      "viewDetails": "Details zur Gewinnbeteiligung anzeigen",
    },
    "tradingHistory": {
      "title": "Handelshistorie (Nur App-Trades)",
      "description": "Zeigt von der DeepTrade-Plattform initiierte Trades",
      "loading": "Lädt...",
      "headers": {
        "date": "Datum",
        "symbol": "Symbol",
        "side": "Seite",
        "size": "Größe",
        "entry": "Einstieg",
        "exit": "Ausstieg",
        "fees": "Gebühren",
        "pnl": "Brutto-G&V",
        "status": "Status",
      },
      "noHistory": "Keine Handelshistorie gefunden. Beginnen Sie mit dem Handel, um Ihre Historie hier zu sehen.",
      "pagination": "Seite {{page}} von {{pages}} ({{total}} Trades insgesamt)",
      "previous": "Vorherige",
      "next": "Nächste",
    },
    "blockedUser": {
      "title": "Handel blockiert:",
      "message": "Unbezahlte Gewinnbeteiligung für Ihre Stufe ({{tier}}). Geschuldet: ${{owed}}. Bitte begleichen Sie Ihr Guthaben, um fortzufahren.",
    },
    "tooltips": {
      "balance": "Ihr aktuelles Kontoguthaben von Ihrer verbundenen Börse.",
      "pnlToday": "Realisierter Gewinn und Verlust aus heute abgeschlossenen Trades.",
      "monthlyRate": "Ihre monatliche Rendite als Prozentsatz.",
      "winRate": "Prozentsatz Ihrer Trades, die profitabel waren."
    }
  },
  "trading": {
    "title": "Handel",
    "signals": "Signale",
    "positions": "Positionen",
    "history": "Verlauf",
    "long": "Long",
    "short": "Short",
    "autoTrading": "Automatischer Handel",
    "autoTradingActive": "Automatischer Handel Aktiv",
    "autoTradingDisabled": "Automatischer Handel Deaktiviert",
    "autoTradingActiveDesc": "Signale werden automatisch ausgeführt",
    "autoTradingDisabledDesc": "Aktivieren Sie die automatische Ausführung von Handelssignalen",
    "noActiveSignals": "Keine aktiven Signale",
    "waitingForSignals": "Warten auf neue Handelsmöglichkeiten...",
    "enableAutoTrading": "Aktivieren Sie den automatischen Handel, um Signale zu erhalten",
    "refreshSignals": "Signale aktualisieren",
    "noOpenPositions": "Keine offenen Positionen",
    "positionsDesc": "Ihre aktiven Handelspositionen werden hier angezeigt",
    "noTradingHistory": "Keine Handelshistorie",
    "historyDesc": "Ihre abgeschlossenen Trades werden hier angezeigt",
    "executeTradeButton": "Trade ausführen",
    "viewDetailsButton": "Details anzeigen",
    "entry": "Einstieg",
    "stopLoss": "Stop Loss",
    "takeProfit": "Take Profit",
    "confidence": "{{value}}% Vertrauen",
    "strategy": "Strategie",
    "firstTp": "Erstes TP",
    "secondTp": "Zweites TP",
    "autoMoveStopLoss": "SL nach erstem TP automatisch auf Breakeven verschieben",
    "tradingMode": "Handelsmodus",
    "paperMode": "Demo",
    "liveMode": "Live",
    "paperTradingActive": "Demo-Handel Aktiv",
    "liveTradingActive": "Live-Handel Aktiv",
    "paperTradingDesc": "Handelsübung mit virtuellen Mitteln",
    "liveTradingDesc": "Handel mit echtem Geld",
    "virtualBalance": "Virtuelles Guthaben",
    "unrealizedPnL": "Unrealisierter P&L",
    "equity": "Eigenkapital",
    "paperTradingHelp": "Demo-Handel Hilfe",
    "resetAccount": "Konto zurücksetzen",
    "paperTradingGuide": "Demo-Handel Leitfaden",
    "paperModeTitle": "Demo-Modus",
    "noProfitSharePaper": "Keine Gewinnbeteiligung im Demo-Modus",
    "paperTradingPositions": "Gesamte Positionen:",
    "paperTradingHistory": "Demo-Handel Verlauf",
    "simulatedTradingHistory": "Simulierter Handelsverlauf",
    "noPaperPositions": "Keine Demo-Handel Positionen",
    "enableAutoTradingPaper": "Demo-Handel generiert automatisch simulierte Positionen basierend auf Marktsignalen",
    "paperTradingMode": "Demo-Handel Modus",
    "autoTradingNotAvailable": "Automatischer Handel nicht verfügbar",
    "autoTradingDisabledPaper": "Automatischer Handel steuert Live-Handel. Demo-Handel generiert automatisch Signale.",
    "riskManagement": "Risikomanagement",
    "riskSettings": "Risikoeinstellungen",
    "investmentPercentage": "Investitionsanteil",
    "leverage": "Hebel",
    "maxLeverage": "Maximaler Hebel",
    "currentTier": "Aktuelle Stufe",
    "exchange": "Börse",
    "accountType": "Kontotyp",
    "marketType": "Markttyp",
    "saveSettings": "Einstellungen speichern",
    "resetToSafe": "Auf sicher zurücksetzen",
    "saving": "Speichern...",
    "riskSettingsSaved": "Risikoeinstellungen erfolgreich gespeichert",
    "failedToSaveRiskSettings": "Fehler beim Speichern der Risikoeinstellungen",
    "position": "Position",
    "internal": "Intern",
    "external": "Extern",
    "marketClose": "Markt schließen",
    "reverse": "Umkehren",
    "editTpSl": "TP/SL",
    "refreshActivePositions": "Aktive Positionen aktualisieren",
    "youHaveNoPosition": "Sie haben keine Position.",
    "noActiveAppPositions": "Keine aktiven App-Positionen gefunden.",
    "noActiveExternalPositions": "Keine aktiven externen Positionen gefunden.",
    "yourActivePositionsWillAppear": "Ihre aktiven Handelspositionen werden hier angezeigt.",
    "previous": "Vorherige",
    "next": "Nächste",
    "learnMore": "Mehr erfahren",
    "paperTradingLabel": "Demo-Handel",
    "recentPaperTrades": "Aktuelle Demo-Trades",
    "noPaperTrades": "Noch keine Demo-Trades",
    "paperTradingAutoGenerate": "Demo-Handel generiert automatisch simulierte Trades basierend auf Marktsignalen",
    "activePositionsTitle": "Aktive Positionen",
    "youHaveNoPositions": "Sie haben keine Positionen.",
    "yourActivePositionsWillAppearHere": "Ihre aktiven Handelspositionen werden hier angezeigt, sobald Sie mit dem Handel beginnen oder den automatischen Handel aktivieren.",
    "max": "Max",
    "tooltips": {
      "virtualBalance": "Ihr realisiertes Guthaben aus abgeschlossenen Trades. Berechnet als: Anfangsguthaben + Gesamt-Netto-P&L aus allen abgeschlossenen Trades.",
      "unrealizedPnL": "Gewinn oder Verlust aus Ihren aktuell offenen Positionen. Dieser Wert ändert sich in Echtzeit basierend auf aktuellen Marktpreisen und ist noch nicht realisiert.",
      "equity": "Ihr gesamter Kontowert einschließlich offener Positionen. Berechnet als: Virtuelles Guthaben + Unrealisierter P&L. Dies stellt Ihren aktuellen Nettowert im Demo-Handel dar.",
      "profitAndLoss": "Realisierter Gewinn und Verlust nur aus abgeschlossenen Trades. Dies beinhaltet nicht den unrealisierten P&L aus offenen Positionen.",
      "balance": "Ihr aktuelles Kontoguthaben, das für den Handel verfügbar ist.",
      "pnlToday": "Realisierter Gewinn und Verlust aus heute abgeschlossenen Trades.",
      "monthlyRate": "Ihre monatliche Rendite berechnet als Prozentsatz Ihres Anfangsguthabens.",
      "winRate": "Prozentsatz der abgeschlossenen Trades, die profitabel waren. Nur aus abgeschlossenen Trades berechnet.",
      "totalReturn": "Ihre Gesamtrendite in Prozent basierend auf dem virtuellen Guthaben. Berechnet als: (Aktuelles virtuelles Guthaben - Anfangsguthaben) / Anfangsguthaben × 100%."
    }
  },
  "common": {
    "loading": "Laden...",
    "error": "Fehler",
    "success": "Erfolg",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "yes": "Ja",
    "no": "Nein",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "on": "EIN",
    "off": "AUS",
    "enabled": "aktiviert",
    "disabled": "deaktiviert",
    "for": "für",
    "warning": "Warning",
    "info": "Information",
    "confirm": "Bestätigen",
    "edit": "Edit",
    "delete": "Delete",
    "close": "Schließen",
    "back": "Zurück",
    "next": "Weiter",
    "previous": "Vorherige",
    "submit": "Submit",
    "reset": "Reset",
    "search": "Search",
    "filter": "Filter",
    "sort": "Sort",
    "refresh": "Refresh",
    "enable": "Aktivieren",
    "disable": "Deaktivieren",
    "toggleOn": "ON",
    "toggleOff": "OFF",
    "ok": "OK",
    "apply": "Anwenden",
    "clear": "Löschen",
    "select": "Auswählen",
    "upload": "Hochladen",
    "download": "Herunterladen",
    "copy": "Kopieren",
    "copied": "Kopiert!",
    "share": "Share",
    "print": "Drucken",
    "export": "Export",
    "import": "Import",
    "and": "und",  },
  "wallet": {
    "connect": "Wallet verbinden",
    "disconnect": "Trennen",
    "connected": "Verbunden",
    "notConnected": "Nicht verbunden",
    "connecting": "Verbinde...",
    "balance": "Guthaben",
    "address": "Adresse",
    "solanaBlockchain": "Betrieben von Solana Blockchain",
    "solanaTooltip": "Auf Solana aufgebaut - Schnelle, sichere und skalierbare Blockchain",
    "wrongNetwork": "Falsches Netzwerk",
    "switchNetwork": "Netzwerk wechseln",
    "transactionPending": "Transaktion ausstehend",
    "transactionConfirmed": "Transaktion bestätigt",
    "transactionFailed": "Transaktion fehlgeschlagen",
    "connectionError": "Verbindungsfehler",
    "connectionFailed": "Wallet-Verbindung fehlgeschlagen",
    "connectionRejected": "Wallet-Verbindung wurde abgelehnt",
    "walletNotFound": "Keine Solana-Wallet gefunden. Bitte installieren Sie eine Wallet wie Phantom.",
    "disconnected": "Wallet getrennt",
    "disconnectedSuccess": "Ihre Wallet wurde erfolgreich getrennt.",
    "disconnectError": "Trennungsfehler",
    "disconnectFailed": "Wallet-Trennung fehlgeschlagen.",
    "confirmDisconnect": "Wallet-Trennung bestätigen",
    "confirmDisconnectMessage": "Sind Sie sicher, dass Sie Ihre Wallet trennen möchten?",
  },
  "notifications": {
    "autoTradingEnabled": "Auto-Trading wurde aktiviert",
    "autoTradingDisabled": "Auto-Trading wurde deaktiviert",
    "settingsSaved": "Einstellungen erfolgreich gespeichert",
    "passwordChanged": "Passwort erfolgreich geändert",
    "profileUpdated": "Profil erfolgreich aktualisiert",
    "walletConnected": "Wallet erfolgreich verbunden",
    "walletDisconnected": "Wallet getrennt",
    "signalExecuted": "Trading-Signal ausgeführt",
    "tradeCompleted": "Handel erfolgreich abgeschlossen",
    "paymentSuccessful": "Zahlung erfolgreich verarbeitet",
    "tierUpgraded": "Stufe erfolgreich aktualisiert",
    "autoTrading": {
      "enabledTitle": "Auto-Trading aktiviert",
      "enabledDescription": "Auto-Trading wurde erfolgreich aktiviert. Guthabenanforderung überprüft.",
      "disabledTitle": "Auto-Trading deaktiviert",
      "disabledDescription": "Auto-Trading wurde erfolgreich deaktiviert.",
      "insufficientBalanceTitle": "Unzureichendes Guthaben",
      "insufficientBalanceDescription": "Mindestguthaben von {{required}} USDT erforderlich. Ihr aktuelles Guthaben beträgt {{current}} USDT.",
      "missingCredentialsTitle": "Fehlende API-Anmeldedaten",
      "missingCredentialsDescription": "Bitte fügen Sie zuerst Ihre Börsen-API-Anmeldedaten hinzu und validieren Sie sie.",
      "balanceVerificationFailedTitle": "Guthabenüberprüfung fehlgeschlagen",
      "balanceVerificationFailedDescription": "Kontoguthaben konnte nicht überprüft werden. Bitte überprüfen Sie Ihre API-Anmeldedaten.",
      "errorTitle": "Auto-Trading-Fehler",
      "errorDescription": "Auto-Trading-Umschaltung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "systemDisabledTitle": "Auto-Trading deaktiviert",
      "noApiCredentialsReason": "Keine Exchange-API-Anmeldedaten konfiguriert. Bitte fügen Sie Ihre API-Schlüssel hinzu.",
      "investmentPercentageReason": "Investitionsprozentsatz ist auf 0% gesetzt. Bitte passen Sie Ihre Risikoeinstellungen an.",
    },
    "paperAutoTrading": {
      "enabledTitle": "Papier-Auto-Trading aktiviert",
      "enabledDescription": "Papier-Trading-Signale werden jetzt automatisch ausgeführt",
      "disabledTitle": "Papier-Auto-Trading deaktiviert",
      "disabledDescription": "Papier-Trading-Signale werden nicht mehr automatisch ausgeführt",
      "errorTitle": "Papier-Auto-Trading-Fehler",
      "errorDescription": "Papier-Auto-Trading-Umschaltung fehlgeschlagen"
    }
  },
  "pagination": {
    "show": "Anzeigen",
    "perPage": "pro Seite",
    "showing": "Zeige {{start}} bis {{end}} von {{total}} Einträgen",
    "previous": "Zurück",
    "next": "Weiter"
  },
  "errors": {
    "generic": "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
    "network": "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.",
    "unauthorized": "Sie sind nicht berechtigt, diese Aktion auszuführen.",
    "forbidden": "Zugriff verweigert.",
    "notFound": "Die angeforderte Ressource wurde nicht gefunden.",
    "serverError": "Serverfehler. Bitte versuchen Sie es später erneut.",
    "validationError": "Bitte überprüfen Sie Ihre Eingabe und versuchen Sie es erneut.",
    "walletNotConnected": "Bitte verbinden Sie zuerst Ihre Wallet.",
    "insufficientBalance": "Unzureichendes Guthaben.",
    "transactionFailed": "Transaktion fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "apiError": "API-Fehler. Kontaktieren Sie den Support, wenn dies anhält.",
  },
  "settings": {
    "title": "Kontoeinstellungen",
    "pleaseLogIn": "Bitte Anmelden",
    "loginRequired": "Sie müssen angemeldet sein, um auf die Kontoeinstellungen zuzugreifen.",
    "goToLogin": "Zur Anmeldung",
    "profile": {
      "title": "Profileinstellungen",
      "description": "Verwalten Sie Ihre Kontoinformationen und Einstellungen",
      "email": "E-Mail-Adresse",
      "currentEmail": "Aktuelle E-Mail",
      "newEmail": "Neue E-Mail-Adresse",
      "updateEmail": "E-Mail aktualisieren",
      "sending": "Senden...",
      "placeholders": {
        "newEmail": "Geben Sie Ihre neue E-Mail-Adresse ein",
        "currentPassword": "Geben Sie Ihr aktuelles Passwort ein"
      }
    },
    "security": {
      "title": "Sicherheitseinstellungen",
      "description": "Verwalten Sie Ihr Passwort und Sicherheitseinstellungen",
      "changePassword": "Passwort ändern",
      "currentPassword": "Aktuelles Passwort",
      "newPassword": "Neues Passwort",
      "confirmPassword": "Neues Passwort bestätigen",
      "enable2FA": "Zwei-Faktor-Authentifizierung",
      "twoFactorEnabled": "Zwei-Faktor-Authentifizierung ist für Ihr Konto aktiviert",
      "twoFactorDisabled": "Zwei-Faktor-Authentifizierung ist für Ihr Konto deaktiviert",
      "changing": "Ändern...",
      "changePasswordButton": "Passwort ändern",
      "verificationCode": "Bestätigungscode",
      "verifyCode": "Code bestätigen",
      "verifying": "Bestätigen...",
      "cancel": "Abbrechen",
      "disable2FA": "Zwei-Faktor-Authentifizierung deaktivieren",
      "disable2FADescription": "Sind Sie sicher, dass Sie 2FA deaktivieren möchten? Dies macht Ihr Konto weniger sicher. Wir senden einen Bestätigungscode an Ihre E-Mail, um diese Aktion zu bestätigen.",
      "sendVerificationCode": "Bestätigungscode senden",
      "disabling": "Deaktivieren...",
      "disable2FAButton": "2FA deaktivieren",
      "resendCode": "Code erneut senden",
      "verifyEmail": "Bestätigen Sie Ihre E-Mail",
      "verifyEmailDescription": "Wir haben einen 6-stelligen Bestätigungscode an Ihre E-Mail gesendet. Geben Sie ihn unten ein, um 2FA zu aktivieren.",
      "verifyEmailToDisable2FA": "E-Mail bestätigen, um 2FA zu deaktivieren",
      "verifyEmailToDisable2FADescription": "Wir haben einen 6-stelligen Bestätigungscode an Ihre E-Mail gesendet. Geben Sie ihn unten ein, um die Zwei-Faktor-Authentifizierung zu deaktivieren.",
      "placeholders": {
        "currentPassword": "Geben Sie Ihr aktuelles Passwort ein",
        "newPassword": "Geben Sie Ihr neues Passwort ein",
        "confirmPassword": "Bestätigen Sie Ihr neues Passwort",
        "verificationCode": "Geben Sie 6-stelligen Code ein"
      }
    },
    "account": {
      "title": "Gefahrenzone",
      "deleteAccount": "Konto löschen",
      "deleteAccountWarning": "Sobald Sie Ihr Konto löschen, gibt es kein Zurück. Bitte seien Sie sicher.",
      "deleteAccountButton": "Konto löschen",
      "deleting": "Löschen...",
      "deleteAccountModal": {
        "title": "Konto löschen",
        "description": "Diese Aktion kann nicht rückgängig gemacht werden. Dies wird Ihr Konto dauerhaft löschen und alle zugehörigen Daten entfernen.",
        "confirmText": "Konto löschen",
        "typedConfirmationText": "LÖSCHEN",
        "permanentlyDelete": "Dies wird dauerhaft löschen:",
        "consequences": [
          "Alle Ihre Daten dauerhaft löschen",
          "Ihre Handelshistorie entfernen",
          "Aktive Abonnements kündigen",
          "Alle API-Anmeldedaten entfernen",
          "Alle Einstellungen und Präferenzen löschen"
        ]
      }
    },
    "errors": {
      "fillAllFields": "Bitte füllen Sie alle Felder aus",
      "passwordsNotMatch": "Die neuen Passwörter stimmen nicht überein",
      "invalidVerificationCode": "Bitte geben Sie den Bestätigungscode ein",
      "invalid6DigitCode": "Bitte geben Sie einen gültigen 6-stelligen Bestätigungscode ein",
      "updateEmailFailed": "E-Mail-Aktualisierung fehlgeschlagen",
      "changePasswordFailed": "Passwort-Änderung fehlgeschlagen",
      "enable2FAFailed": "2FA-Aktivierung fehlgeschlagen",
      "verify2FAFailed": "2FA-Code-Bestätigung fehlgeschlagen",
      "disable2FAFailed": "Bestätigungscode zum Deaktivieren senden fehlgeschlagen",
      "disable2FAVerifyFailed": "2FA-Deaktivierung fehlgeschlagen",
      "deleteAccountFailed": "Konto-Löschung fehlgeschlagen"
    },
    "success": {
      "verificationEmailSent": "Bestätigungs-E-Mail gesendet",
      "verificationEmailDescription": "Bitte überprüfen Sie {{email}} für Bestätigungsanweisungen.",
      "passwordChanged": "Passwort geändert",
      "passwordChangedDescription": "Ihr Passwort wurde erfolgreich aktualisiert.",
      "2FACodeSent": "2FA-Code gesendet",
      "2FACodeSentDescription": "Bitte überprüfen Sie Ihre E-Mail für den Bestätigungscode.",
      "2FAEnabled": "2FA aktiviert",
      "2FAEnabledDescription": "Zwei-Faktor-Authentifizierung wurde erfolgreich aktiviert.",
      "verificationCodeSent": "Bestätigungscode gesendet",
      "verificationCodeSentDescription": "Bitte überprüfen Sie Ihre E-Mail für den 6-stelligen Bestätigungscode zum Deaktivieren von 2FA.",
      "2FADisabled": "2FA deaktiviert",
      "2FADisabledDescription": "Zwei-Faktor-Authentifizierung wurde erfolgreich deaktiviert.",
      "accountDeleted": "Konto gelöscht",
      "accountDeletedDescription": "Ihr Konto wurde erfolgreich gelöscht."
    }
  },
  "accessSecurity": {
    "title": "Zugang & Sicherheit",
    "subtitle": "Überwachen Sie Ihre Kontosicherheit und Anmeldeaktivität",
    "totalLogins": "Gesamte Anmeldungen",
    "successRate": "Erfolgsrate",
    "uniqueIPs": "Eindeutige IPs",
    "twoFactorStatus": "2FA-Status",
    "enabled": "Aktiviert",
    "disabled": "Deaktiviert",
    "currentSession": "Aktuelle Sitzung",
    "currentSessionDescription": "Informationen über Ihre aktuelle Anmeldesitzung",
    "recentLoginActivity": "Kürzliche Anmeldeaktivität",
    "recentLoginDescription": "Ihre kürzlichen Anmeldeversuche und Sitzungen",
    "refresh": "Aktualisieren",
    "ipAddress": "IP-Adresse",
    "timestamp": "Zeitstempel",
    "status": "Status",
    "userAgent": "Benutzeragent",
    "successful": "Erfolgreich",
    "failed": "Fehlgeschlagen",
    "noLoginActivity": "Keine Anmeldeaktivität gefunden",
    "currentDevice": "Aktuelles Gerät",
    "location": "Standort",
    "sessionStart": "Sitzungsbeginn",
    "lastLoginActivity": "Letzte Anmeldeaktivität",
    "lastLoginDescription": "Ihre letzte erfolgreiche Anmeldung",
    "loginTime": "Anmeldezeit",
    "browser": "Browser",
    "lastThirtyDays": "Letzte 30 Tage",
    "loginSuccessRate": "Anmelde-Erfolgsrate",
    "differentLocations": "Verschiedene Standorte",
    "never": "Niemals",
    "unknown": "Unbekannt",
    "reason": "Grund:",
    "authenticationRequired": "Authentifizierung erforderlich",
    "authenticationRequiredDescription": "Bitte melden Sie sich an, um Ihre Sicherheitsinformationen zu sehen.",
    "errors": {
      "authenticationError": "Authentifizierungsfehler",
      "authenticationErrorDescription": "Bitte melden Sie sich erneut an, um Sicherheitsdaten zu sehen.",
      "networkError": "Netzwerkfehler",
      "networkErrorDescription": "Fehler beim Abrufen der Sicherheitsdaten. Bitte überprüfen Sie Ihre Verbindung.",
      "refreshFailed": "Aktualisierung fehlgeschlagen",
      "refreshFailedDescription": "Fehler beim Aktualisieren der Sicherheitsdaten. Bitte versuchen Sie es erneut."
    },
    "success": {
      "dataRefreshed": "Sicherheitsdaten aktualisiert",
      "dataRefreshedDescription": "Ihre Sicherheitsinformationen wurden erfolgreich aktualisiert."
    }
  },
  "tiers": {
    "title": "Stufen-Verwaltung",
    "currentTier": "Aktuelle Stufe",
    "choosePlan": "Wählen Sie Ihren Plan",
    "tier1": {
      "name": "Stufe 1",
      "subtitle": "Kostenlos",
      "description": "Perfekt für den Einstieg mit grundlegenden Trading-Signalen",
      "features": [
        "Grundlegende Trading-Signale",
        "Manuelle Handelsausführung",
        "Community-Support",
        "Grundlegende Marktanalyse"
      ]
    },
    "tier2": {
      "name": "Stufe 2",
      "subtitle": "30 Tage Zugang",
      "description": "Erweiterte Funktionen für ernsthafte Trader",
      "features": [
        "Erweiterte KI-Trading-Signale",
        "Auto-Trading-Funktionen",
        "Prioritäts-Support",
        "Erweiterte Analytik",
        "Risikomanagement-Tools"
      ]
    },
    "tier3": {
      "name": "Stufe 3",
      "subtitle": "NFT erforderlich",
      "description": "Premium-Stufe mit exklusiven Funktionen",
      "features": [
        "Premium-Trading-Signale",
        "Erweiterte Auto-Trading",
        "VIP-Support",
        "Exklusive Markteinblicke",
        "Benutzerdefinierte Strategien"
      ]
    },
    "activate": "Aktivieren",
    "current": "Aktuell",
    "paymentRequired": "Zahlung erforderlich",
    "nftRequired": "NFT erforderlich",
    "membershipStatus": "Mitgliedschaftsstatus",
    "active": "Aktiv",
    "expired": "Abgelaufen",
    "daysRemaining": "Verbleibende Tage",
    "expiresOn": "Läuft ab am",
  },
  "apiCredentials": {
    "title": "API-Anmeldedaten",
    "description": "Verwalten Sie Ihre Exchange-API-Anmeldedaten für den Handel",
    "addCredentials": "API-Anmeldedaten hinzufügen",
    "exchange": "Börse",
    "exchanger": "Tauscher",
    "apiKey": "API-Schlüssel",
    "apiSecret": "API-Geheimnis",
    "secretKey": "Geheimer Schlüssel",
    "passphrase": "Passphrase",
    "testConnection": "Verbindung testen",
    "save": "Anmeldedaten speichern",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "status": "Status",
    "connected": "Verbunden",
    "disconnected": "Getrennt",
    "invalid": "Ungültig",
    "active": "Aktiv",
    "testing": "Teste...",
    "connectionSuccess": "Verbindung erfolgreich",
    "connectionFailed": "Verbindung fehlgeschlagen",
    "credentialsAdded": "API-Anmeldedaten erfolgreich hinzugefügt",
    "credentialsUpdated": "API-Anmeldedaten erfolgreich aktualisiert",
    "credentialsDeleted": "API-Anmeldedaten erfolgreich gelöscht",
    "credentialAddedLimitReached": "Anmeldedaten hinzugefügt (Limit erreicht)",
    "requiredMarketType": "Erforderlicher Markttyp",
    "connectedTo": "Verbunden mit",
    "connectionNeedsAttention": "Verbindung zu",
    "needsAttention": "benötigt Aufmerksamkeit",
    "lastUpdated": "Zuletzt aktualisiert",
    "updateCredentialsMessage": "Bitte aktualisieren Sie Ihre API-Anmeldedaten, um den Handel fortzusetzen",
    "disconnect": "Trennen",
    "disconnecting": "Trenne...",
    "setAsActive": "Als aktiv setzen",
    "activating": "Aktiviere...",
    "autoTrading": "Auto-Trading",
    "enableAutoTradingDesc": "Automatisierten Handel für diese Börse aktivieren",
    "tier2LimitReached": "Tier 2 Limit erreicht: bis zu zwei CEX-Anmeldedaten erlaubt.",
    "add": "Hinzufügen",
    "update": "Aktualisieren",
    "connectionValidated": "Verbindung validiert!",
    "autoTradingStatusChanged": "Auto-Trading wurde",
    "marketTypes": {
      "futures": "Futures",
      "spot": "Spot",
      "binanceNote": "Futures-Handel - Hebel bis zu 125x verfügbar",
      "binanceUsNote": "Spot-Handel mit Marge - Hebel bis zu 3x verfügbar",
      "krakenNote": "Futures-Handel - Hebel bis zu 100x verfügbar",
      "bybitNote": "Futures-Handel - Hebel bis zu 100x verfügbar",
      "hyperliquidNote": "Perpetual Futures-Handel - Hebel bis zu 50x verfügbar",
      "standardNote": "Standard-Spot-Handel",
    },
    "errors": {
      "loadFailed": "Laden der Anmeldedaten fehlgeschlagen",
      "keysRequired": "API-Schlüssel und geheimer Schlüssel sind erforderlich",
      "tierUndetermined": "Benutzer-Tier kann nicht bestimmt werden",
      "tier1Limit": "Tier 1 erlaubt nur eine API-Anmeldedaten",
      "tier2PerCex": "Tier 2 erlaubt nur eine Anmeldedaten pro CEX",
      "tier2Limit": "Tier 2 erlaubt bis zu zwei Anmeldedaten (eine pro CEX)",
      "tier3Limit": "Tier 3 erlaubt nur eine Anmeldedaten für alle CEXs",
      "saveFailed": "Speichern fehlgeschlagen",
      "validationFailed": "Validierung fehlgeschlagen",
      "activationFailed": "Aktivierung fehlgeschlagen",
      "deactivationFailed": "Deaktivierung fehlgeschlagen",
      "noCredentials": "Keine Anmeldedaten für diese Börse gefunden",
      "autoTradingUpdateFailed": "Auto-Trading-Update fehlgeschlagen",
      "autoTradingUpdateFailedDesc": "Auto-Trading-Einstellungen konnten nicht aktualisiert werden",
    },
    "success": {
      "credentialsSaved": "Anmeldedaten gespeichert",
      "connectionSuccessful": "Verbindung erfolgreich",
      "activated": "Aktiviert",
      "deactivated": "Deaktiviert",
      "autoTradingEnabled": "Auto-Trading aktiviert",
      "autoTradingDisabled": "Auto-Trading deaktiviert",
    }
  },
  "referrals": {
    "title": "Empfehlungs-Dashboard",
    "loading": "Lade Empfehlungs-Dashboard...",
    "referralLink": "Empfehlungslink",
    "referralLinkDescription": "Teilen Sie diesen Link, um {{rate}}% von den Gewinnbeteiligungszahlungen Ihrer Empfehlungen zu verdienen.",
    "tierNames": {
      "tier1": "Stufe 1",
      "tier2": "Stufe 2",
      "tier3": "Stufe 3"
    },
    "settings": {
      "title": "Einstellungen",
      "referralSettings": "Empfehlungseinstellungen",
      "solanaWalletAddress": "Solana Wallet-Adresse",
      "walletPlaceholder": "Geben Sie Ihre Solana Wallet-Adresse für Zahlungen ein",
      "minimumPayoutAmount": "Mindestausschüttungsbetrag ($)",
      "enableAutomaticPayments": "Automatische Zahlungen aktivieren",
      "autoPaymentEnabled": "Wenn aktiviert, erhalten Sie automatisch Empfehlungszahlungen, wenn sie fällig sind.",
      "autoPaymentDisabled": "Wenn deaktiviert, erhalten Sie keine Empfehlungszahlungen, bis dies wieder aktiviert wird.",
      "saveSettings": "Einstellungen speichern",
      "importantWarning": "Wichtige Warnung:",
      "warnings": {
        "ensureCorrectAddress": "Bitte stellen Sie sicher, dass Ihre Solana Wallet-Adresse korrekt ist",
        "doubleCheckAddress": "Überprüfen Sie die Adresse vor dem Speichern doppelt",
        "notResponsible": "DeepTrade ist NICHT verantwortlich für Zahlungen an falsche oder ungültige Adressen",
        "cannotRecover": "Verlorene Gelder aufgrund falscher Adressen können nicht wiederhergestellt werden"
      },
      "minimumPayoutRequirements": "Mindestausschüttungsanforderungen:",
      "requirements": {
        "minimumAmount": "Mindestausschüttungsbetrag: $10.00 USDT",
        "gasFeeDeducted": "Solana-Netzwerk-Gasgebühren werden von der Ausschüttung abgezogen",
        "estimatedGasFee": "Geschätzte Gasgebühr: ~0.001 SOL (~$0.10-$0.50)",
        "payoutsProcessed": "Ausschüttungen werden in USDT im Solana-Netzwerk verarbeitet"
      }
    },
    "overview": {
      "totalReferrals": "Gesamte Empfehlungen",
      "activeCount": "{{count}} aktiv",
      "totalEarnings": "Gesamte Einnahmen",
      "totalPaid": "${{amount}} bezahlt",
      "pendingPayout": "Ausstehende Ausschüttung",
      "requestPayout": "Ausschüttung anfordern",
      "earningRate": "Verdienstrate"
    },
    "actions": {
      "copy": "Kopieren",
      "generateNew": "Neu generieren"
    },
    "recentActivity": {
      "recentReferrals": "Aktuelle Empfehlungen",
      "recentEarnings": "Aktuelle Einnahmen",
      "noReferrals": "Noch keine Empfehlungen. Beginnen Sie, Ihren Link zu teilen!",
      "noEarnings": "Noch keine Einnahmen. Empfehlungen müssen mit dem Trading beginnen!",
      "earned": "${{amount}} verdient"
    },
    "status": {
      "verified": "Verifiziert",
      "pending": "Ausstehend",
      "paid": "Bezahlt"
    },
    "messages": {
      "copied": "Kopiert!",
      "linkCopied": "Empfehlungslink in die Zwischenablage kopiert",
      "newCodeGenerated": "Neuer Empfehlungscode generiert",
      "profileUpdated": "Profil erfolgreich aktualisiert",
      "payoutRequestSubmitted": "Ausschüttungsanfrage eingereicht"
    },
    "errors": {
      "failedToLoadData": "Fehler beim Laden der Empfehlungsdaten",
      "failedToGenerateCode": "Fehler beim Generieren des neuen Codes",
      "invalidMinimumPayout": "Ungültige Mindestausschüttung",
      "minimumPayoutRequired": "Die Mindestausschüttung muss mindestens $10.00 betragen",
      "invalidWalletAddress": "Ungültige Wallet-Adresse",
      "validWalletRequired": "Bitte geben Sie eine gültige Solana Wallet-Adresse ein",
      "failedToUpdateProfile": "Fehler beim Aktualisieren des Profils",
      "failedToRequestPayout": "Fehler beim Anfordern der Ausschüttung"
    }
  },

  "paperTradingHelp": {
    "title": "Demo-Handel Leitfaden",
    "whatIsPaperTrading": "Was ist Demo-Handel?",
    "whatIsPaperTradingDesc": "Demo-Handel ist eine simulierte Handelsumgebung, die es Ihnen ermöglicht, Handelsstrategien mit virtuellem Geld anstatt echten Mitteln zu üben. Es ist der perfekte Weg, unser KI-Handelssystem ohne finanzielles Risiko zu testen.",
    "keyBenefits": "Hauptvorteile",
    "riskFree": "Risikofreies Lernen",
    "riskFreeDesc": "Üben Sie mit virtuellen Mitteln - kein echtes Geld im Risiko",
    "realMarketData": "Echte Marktdaten",
    "realMarketDataDesc": "Erleben Sie Live-Marktbedingungen und Preisbewegungen",
    "aiTradingSystem": "KI-Handelssystem",
    "aiTradingSystemDesc": "Testen Sie unsere fortschrittlichen KI-Signale in einer sicheren Umgebung",
    "buildConfidence": "Vertrauen aufbauen",
    "buildConfidenceDesc": "Entwickeln Sie Ihre Handelsfähigkeiten, bevor Sie echtes Geld verwenden",
    "howItWorks": "Wie es funktioniert",
    "step1": "Zu Demo-Modus wechseln",
    "step1Desc": "Schalten Sie den Handelsmodus-Schalter um, um Demo-Handel zu aktivieren",
    "step2": "Virtuelles Guthaben",
    "step2Desc": "Beginnen Sie mit $10.000 virtuellem Guthaben (kann zurückgesetzt werden)",
    "step3": "KI-Signale",
    "step3Desc": "Unsere KI generiert Handelssignale basierend auf echten Marktdaten",
    "step4": "Simulierte Trades",
    "step4Desc": "Trades werden virtuell ausgeführt - verfolgen Sie Ihre Leistung",
    "importantNotes": "Wichtige Hinweise",
    "noRealMoney": "Kein echtes Geld",
    "noRealMoneyDesc": "Demo-Handel verwendet nur virtuelle Mittel. Es entstehen keine echten Gewinne oder Verluste.",
    "noRealFees": "Keine echten Gebühren",
    "noRealFeesDesc": "Handelsgebühren und Slippage werden für eine realistische Erfahrung simuliert.",
    "performanceTracking": "Leistungsverfolgung",
    "performanceTrackingDesc": "Alle Statistiken und Analysen basieren nur auf simulierten Trades.",
    "readyToStart": "Bereit anzufangen?",
    "readyToStartDesc": "Schalten Sie den \"Handelsmodus\"-Schalter auf \"Demo\" und beginnen Sie noch heute mit dem Üben mit virtuellen Mitteln!",
    "buildConfidenceFooter": "💪 Bauen Sie Vertrauen mit Demo-Handel auf, bevor Sie echtes Geld riskieren!",
    "resetModal": {
      "title": "Demo-Handel Konto zurücksetzen",
      "warning": "Warnung: Diese Aktion kann nicht rückgängig gemacht werden",
      "warningDesc": "Dies wird dauerhaft Ihre gesamte Demo-Handelshistorie löschen und Ihr virtuelles Guthaben zurücksetzen.",
      "resetLimitReached": "Tägliches Reset-Limit erreicht",
      "resetLimitReachedDesc": "Sie haben alle 3 Resets für heute verwendet. Das Limit wird um Mitternacht UTC zurückgesetzt.",
      "resetsRemaining": "Verbleibende Resets heute: {{count},",
      "currentBalance": "Aktuelles Guthaben: ${{balance},",
      "resetToDefault": "Auf Standard $10.000 zurücksetzen",
      "customBalance": "Benutzerdefiniertes Guthaben festlegen",
      "customBalanceDesc": "Geben Sie ein benutzerdefiniertes Startguthaben ein (mindestens $1.000)",
      "confirmationRequired": "Geben Sie 'RESET' zur Bestätigung ein",
      "confirmationPlaceholder": "Geben Sie hier RESET ein...",
      "confirmationRequiredError": "Bitte geben Sie 'RESET' zur Bestätigung ein",
      "invalidBalance": "Ungültiges Guthaben",
      "invalidBalanceDesc": "Bitte geben Sie einen gültigen positiven Guthabenbetrag ein",
      "resetting": "Zurücksetzen...",
      "resetButton": "Konto zurücksetzen",
    },
    "howItWorksModal": {
      "title": "Wie Demo-Handel funktioniert",
      "step1": "Beginnen Sie mit $10.000 virtuellem Guthaben (konfigurierbar)",
      "step2": "Aktivieren Sie den automatischen Handel, damit die KI Trades automatisch ausführt",
      "step3": "Überwachen Sie die Leistung und passen Sie die Risikoeinstellungen nach Bedarf an",
      "step4": "Wechseln Sie zum Live-Handel, wenn Sie Vertrauen in das System haben",
    },
    "importantNotesDetails": {
      "noRealMoneyTitle": "Kein echtes Geld:",
      "noRealMoneyDesc": "Demo-Handel verwendet nur virtuelle Mittel. Es entstehen keine echten Gewinne oder Verluste.",
      "noFeesTitle": "Keine Gebühren:",
      "noFeesDesc": "Demo-Handel generiert keine Gewinnbeteiligungsgebühren, da keine echten Gewinne erzielt werden.",
      "resetLimitTitle": "Reset-Limit:",
      "resetLimitDesc": "Sie können Ihr Demo-Konto bis zu 3 Mal pro Tag zurücksetzen.",
    },
    "benefits": {
      "title": "Vorteile des Demo-Handels",
      "riskFreeLearning": "Risikofreies Lernen",
      "riskFreeLearningDesc": "Üben Sie, ohne echtes Geld zu verlieren, während Sie lernen, wie unser KI-System funktioniert",
      "strategyTesting": "Strategietests",
      "strategyTestingDesc": "Testen Sie verschiedene Risikoeinstellungen und sehen Sie, wie sie sich im Laufe der Zeit entwickeln",
      "realMarketData": "Echte Marktdaten",
      "realMarketDataDesc": "Verwendet Live-Marktpreise und echte ML-Prognosen für eine authentische Erfahrung",
    },
    "gettingStarted": {
      "title": "Bereit anzufangen?",
      "description": "Schalten Sie den \"Handelsmodus\"-Schalter auf \"Demo\" und beginnen Sie noch heute mit dem Üben mit virtuellen Mitteln!",
      "buildConfidenceFooter": "💪 Bauen Sie Vertrauen mit Demo-Handel auf, bevor Sie echtes Geld riskieren!",
    },
    "perfectForBeginners": "💡 Perfekt für Anfänger und erfahrene Trader, die neue Strategien testen möchten!",
    "availableToAllTitle": "Für Alle Verfügbar:",
    "availableToAllDesc": "Demo-Handel ist für alle Benutzer unabhängig vom Tier-Level verfügbar.",
    "gotItThanks": "Verstanden, danke!",
  },

  "paperTradingDashboard": {
    "performance": {
      "title": "Demo-Handel Leistung",
      "refresh": "Aktualisieren",
      "reset": "Zurücksetzen",
      "totalReturn": "Gesamtrendite",
    },

    "errors": {
      "loadFailed": "Fehler beim Laden der Demo-Handel-Daten",
    }
  },
  "tradingSignalStatus": {
    "title": "Handelssignal-Status",
    "description": "Live-Status aus der systemweiten Signalübertragung",
    "signalLabel": "Signal",
    "confidenceLabel": "KI-Signal-Konfidenz",
    "lastUpdateLabel": "Letzte Aktual.",
    "errorLoading": "Fehler beim Laden des Handelsstatus",
    "signals": {
      "HOLD": "HALTEN",
      "BUY": "KAUFEN",
      "SELL": "VERKAUFEN",
      "LONG": "Long",
      "SHORT": "Short",
      "long": "Long",
      "short": "Short"
    }
  },
  "tier": {
    "choosePlan": "Wählen Sie Ihren Plan",
    "membershipStatus": {
      "title": "Mitgliedschaftsstatus",
      "active": "Aktiv",
      "expired": "Abgelaufen",
      "daysRemaining": "Verbleibende Tage:",
      "expiresOn": "Läuft ab am:"
    },
    "modals": {
      "activateTier": "Stufe {{tierName}} aktivieren",
      "confirmActivation": "Sind Sie sicher, dass Sie Stufe {{tierName}} aktivieren möchten?",
      "confirmTierChange": "Stufenwechsel bestätigen",
      "confirmSwitch": "Sind Sie sicher, dass Sie zu Stufe {{tierName}} wechseln möchten?",
      "cancel": "Abbrechen",
      "activate": "Aktivieren",
      "confirm": "Bestätigen"
    },
    "tiers": {
      "starter": {
        "name": "Stufe 1: Starter",
        "price": "Kostenlos",
        "description": "Perfekt für den Einstieg",
        "features": [
          "Grundlegende Trading-Signale",
          "Trading-Hebel bis zu 2,5x",
          "Begrenzt auf einen API-Zugang",
          "40% Gewinnbeteiligungsgebühr"
        ]
      },
      "pro": {
        "name": "Stufe 2: Pro",
        "description": "Für ernsthafte Trader",
        "accessInstructions": "Um auf diese Stufe zuzugreifen, verwenden Sie die Wallet-Schaltfläche in der oberen Navigationsleiste, um Ihre Solana-Wallet zu verbinden und für 30 Tage Zugang zu bezahlen.",
        "features": [
          "Erweiterte Trading-Signale",
          "Trading-Hebel bis zu 5x",
          "Begrenzt auf zwei API-Zugänge",
          "20% Gewinnbeteiligungsgebühr"
        ]
      },
      "nftElite": {
        "name": "Stufe 3: NFT Elite",
        "price": "Lebenslang",
        "description": "Für verifizierte Capitolchilax NFT-Sammler.",
        "visitWebsite": "Besuchen Sie capitolchilax.com",
        "accessInstructions": "Um auf diese Stufe zuzugreifen, verwenden Sie die Wallet-Schaltfläche in der oberen Navigationsleiste, um zu verbinden und Ihre NFT-Berechtigung zu überprüfen.",
        "features": [
          "Erweiterte Trading-Signale",
          "Trading-Hebel bis zu 10x",
          "Unbegrenzte API-Verbindungen",
          "10% Gewinnbeteiligungsgebühr",
          "Keine monatliche Mitgliedschaftsgebühr"
        ]
      }
    },
    "status": {
      "currentTier": "Aktuelle Stufe",
      "alreadyUnlocked": "Bereits freigeschaltet",
      "yourCurrentTier": "Ihre aktuelle Stufe",
      "currentlyOn": "Sie befinden sich derzeit auf {{tierName}}"
    },
    "buttons": {
      "paymentRequired": "Zahlung erforderlich",
      "connectWallet": "Wallet verbinden",
      "nftRequired": "NFT erforderlich",
      "select": "{{tierName}} auswählen",
      "activate": "{{tierName}} aktivieren",
      "payToReactivate": "Zahlen zur Reaktivierung",
      "payWithToken": "Mit {{token}} bezahlen",
      "connectWalletFirst": "Wallet zuerst verbinden",
      "proceedWithPayment": "Mit Zahlung fortfahren"
    },
    "nft": {
      "verifyingOwnership": "NFT-Besitz wird überprüft...",
      "nftRequired": "Sie müssen eine spezifische NFT besitzen, um auf diese Stufe zuzugreifen",
      "nftOwned": "Sie besitzen eine NFT aus der erforderlichen Sammlung."
    },
    "payment": {
      "thirtyDaysAccess": "30 Tage Zugang",
      "thirtyDaysAccessDue": "30 Tage Zugang fällig",
      "paymentDetails": "Zahlungsdetails",
      "amount": "Betrag:",
      "network": "Netzwerk:",
      "wallet": "Wallet:",
      "connectionStatus": "Verbindungsstatus:",
      "connected": "Verbunden",
      "disconnected": "Getrennt",
      "processing": "Zahlung wird verarbeitet",
      "processingDescription": "Bitte bestätigen Sie die Transaktion in Ihrer Wallet und warten Sie auf die Bestätigung...",
      "successful": "Zahlung erfolgreich!",
      "successDescription": "Ihre Zahlung wurde erfolgreich verarbeitet. Ihre Stufe wird in Kürze aktualisiert.",
      "failed": "Zahlung fehlgeschlagen",
      "failedDescription": "Bei der Verarbeitung Ihrer Zahlung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "tryAgain": "Erneut versuchen",
      "thirtyDaysAccessDescription": "Schließen Sie Ihre Zahlung für 30 Tage Zugang ab, um Pro-Funktionen zu aktivieren.",
      "importantNotes": "Wichtige Hinweise",
      "paymentWarnings": [
        "Stellen Sie sicher, dass Sie genügend {{token}} in Ihrer Wallet haben",
        "Behalten Sie etwas SOL für Transaktionsgebühren (~0,001 SOL)",
        "Die Zahlung wird im Solana-Mainnet verarbeitet",
        "Die Transaktion ist nach der Bestätigung unumkehrbar"
      ]
    },
    "paymentHistory": {
      "title": "Zahlungshistorie",
      "profitShare": "Gewinnbeteiligung",
      "thirtyDaysAccess": "30 Tage Zugang",
      "billingPeriod": "${{amount}} fällig für {{startDate}} - {{endDate}}"
    },
    "errors": {
      "paymentRequired": "Sie müssen Ihre ausstehenden Gewinnbeteiligungsgebühren (${{amount}}) bezahlen, bevor Sie die Stufe wechseln können.",
      "downgradeNotAllowed": "Sie können nicht von Stufe {{currentTier}} auf Stufe {{newTier}} herabstufen. Sie können nur auf höhere Stufen upgraden.",
      "downgradeNotAllowedTitle": "Herabstufung nicht erlaubt",
      "walletConnectionRequired": "Bitte verbinden Sie Ihre Solana-Wallet, um auf Stufe 2 zuzugreifen.",
      "walletConnectionRequiredTitle": "Wallet-Verbindung erforderlich",
      "nftRequired": "Sie müssen eine spezifische NFT besitzen, um auf diese Stufe zuzugreifen.",
      "membershipExpired": "Ihre Stufe 2-Mitgliedschaft ist abgelaufen. Sie wurden auf die Starter-Stufe herabgestuft.",
      "membershipExpiredTitle": "Mitgliedschaft abgelaufen",
      "walletDisconnected": "Ihr Stufenstatus wurde beibehalten.",
      "walletDisconnectedTitle": "Wallet getrennt",
      "walletDisconnectedWithDays": "Ihr Stufe 2-Zugang bleibt für weitere {{days}} Tage aktiv.",
      "couldNotValidate": "Ihr Stufenstatus wurde beibehalten. Verbinden Sie Ihre Wallet erneut, um Zahlungen zu tätigen.",
      "failedToFetchTier": "Fehler beim Abrufen des Stufenstatus",
      "errorLoadingTier": "Fehler beim Laden der Stufeninformationen",
      "dataFetchError": "Fehler beim Abrufen der Stufendaten: {{error}}",
      "dataFetchErrorTitle": "Datenabruffehler",
      "walletNotConnected": "Bitte verbinden Sie Ihre Solana-Wallet, um mit der Zahlung fortzufahren.",
      "walletNotConnectedTitle": "Wallet nicht verbunden",
      "paymentFailed": "Bei der Verarbeitung Ihrer Zahlung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "paymentSuccessful": "Ihre {{type}}-Zahlung wurde erfolgreich verarbeitet!",
      "activationFailed": "Aktivierung der Stufe fehlgeschlagen. Bitte versuchen Sie es erneut."
    },
    "profitShare": {
      "paymentDueTitle": "Gewinnbeteiligungszahlung fällig",
      "accountDisabled": "Konto deaktiviert",
      "status": "Gewinnbeteiligungsstatus",
      "paymentWasDue": "Zahlung war fällig:",
      "paymentDue": "Zahlung fällig:",
      "nextPaymentDeadline": "Nächste Zahlungsfrist:",
      "payNow": "Jetzt bezahlen",
      "payToReactivate": "Zahlen zur Reaktivierung",
      "overdue": "ÜBERFÄLLIG",
      "accountDisabledMessage": "Konto deaktiviert - Zahlung erforderlich",
      "paymentOverdue": "Zahlung überfällig",
      "paymentDueSoon": "Zahlung bald fällig",
      "wasDue": "War fällig:",
      "due": "Fällig:",
      "youOwe": "Sie schulden ${{amount}} an Gewinnbeteiligungsgebühren",
      "allCaughtUp": "Keine ausstehenden Gewinnbeteiligungsgebühren - Sie sind auf dem neuesten Stand! 🎉",
      "scheduleInfo": "Gewinnbeteiligungszahlungen sind jeden Samstag um 0:00 GMT fällig",
      "disableWarning": "Konten werden jeden Samstag um 0:00 GMT wegen unbezahlter Gebühren deaktiviert",
      "deadlineApproaching": "Zahlungsfrist nähert sich",
      "deadlineMessage": "Ihre Gewinnbeteiligungszahlung von ${{amount}} ist bis Samstag um 0:00 GMT fällig. Ihr Konto wird automatisch deaktiviert, wenn die Zahlung nicht bis zur Frist eingeht.",
      "accountTradingDisabled": "Konto-Trading deaktiviert",
      "accountDisabledDescription": "Ihr Trading-Konto ist aufgrund ausstehender Gewinnbeteiligungsgebühren deaktiviert. Zahlen Sie ${{amount}}, um das Trading zu reaktivieren.",
      "accountSuspendedWarning": "⚠️ Ihr Konto wurde aufgrund unbezahlter Gebühren deaktiviert. Das Trading ist bis zur Zahlung ausgesetzt.",
      "disabledOn": "Deaktiviert am:",
      "deadline": "Frist:"
    },
    "coupon": {
      "redeemButton": "Haben Sie einen Gutschein? Hier einlösen",
      "redeemDescription": "Upgraden Sie Ihre Stufe sofort mit einem Gutscheincode"
    },
    "pricing": {
      "free": "Kostenlos",
      "lifetime": "Lebenslang",
      "thirtyDayAccess": "${{price}} für 30 Tage Zugang"
    },
    "success": {
      "tierUpdated": "Ihre Stufe wurde auf {{tierName}} aktualisiert.",
      "tierActivated": "Ihre Stufe wurde erfolgreich aktualisiert.",
      "paymentSuccessful": "Ihre {{type}}-Zahlung wurde erfolgreich verarbeitet!"
    },
    "notifications": {
      "accountDisabled": {
        "title": "🚫 Konto deaktiviert",
        "description": "Ihr Konto wurde aufgrund unbezahlter Gewinnbeteiligungsgebühren von ${{amount}} deaktiviert. Bitte tätigen Sie eine Zahlung, um Ihr Konto zu reaktivieren."
      },
      "paymentOverdue": {
        "title": "⚠️ Zahlung überfällig",
        "description": "Ihre Gewinnbeteiligungszahlung von ${{amount}} ist überfällig. Ihr Konto könnte bald deaktiviert werden."
      },
      "paymentReminder": {
        "title": "⏰ Zahlungserinnerung",
        "description": "Ihre Gewinnbeteiligungszahlung von ${{amount}} ist bis Samstag 0:00 GMT fällig. Bitte zahlen Sie, um eine Kontosperrung zu vermeiden."
      }
    }
  },
  "help": {
    "title": "Hilfe & Support",
    "description": "Finden Sie Antworten auf häufige Fragen, überprüfen Sie unsere rechtlichen Richtlinien und kontaktieren Sie unser Support-Team.",
    "faqTab": "FAQ",
    "legalTab": "Rechtliches",
    "contactTab": "Kontakt",
    "faqSection": {
      "categories": {
        "general": "Allgemein",
        "trading": "Trading",
        "tiers": "Stufen",
        "setup": "Einrichtung",
        "security": "Sicherheit",
        "billing": "Abrechnung"
      },
      "items": {
        "whatIsDeepTrade": {
          "question": "Was ist DeepTrade?",
          "answer": "DeepTrade ist eine KI-gestützte Kryptowährungs-Trading-Plattform, die automatisierte Trading-Signale und Portfolio-Management-Tools mit fortschrittlichen Machine-Learning-Algorithmen bereitstellt."
        },
        "howSignalsWork": {
          "question": "Wie funktionieren Trading-Signale?",
          "answer": "Unsere KI analysiert Marktdaten in Echtzeit, um Kauf-/Verkaufssignale mit Einstiegspunkten, Stop-Losses und Take-Profit-Levels zu generieren. Sie können diese manuell ausführen oder Auto-Trading aktivieren."
        },
        "tierLevels": {
          "question": "Was sind die verschiedenen Tier-Level?",
          "answer": "Tier 1 (Kostenlos): Grundlegende Signale. Tier 2 ($50/Monat): Erweiterte Signale + Auto-Trading. Tier 3 (NFT erforderlich): Premium-Features + Priority-Support."
        },
        "connectExchange": {
          "question": "Wie verbinde ich mein Exchange-Konto?",
          "answer": "Gehen Sie zu API-Anmeldedaten in Ihrem Dashboard, fügen Sie Ihre Exchange-API-Schlüssel hinzu (nur Lesen empfohlen), und unser System validiert die Verbindung."
        },
        "dataSecure": {
          "question": "Sind meine Daten sicher?",
          "answer": "Ja, wir verwenden branchenübliche Verschlüsselung, speichern niemals Ihre privaten Schlüssel und empfehlen nur-Lesen-API-Zugriff für maximale Sicherheit."
        },
        "profitShares": {
          "question": "Wie funktionieren Gewinnbeteiligungen?",
          "answer": "Für Tier 2+ Benutzer berechnen wir einen kleinen Prozentsatz der durch unsere Signale generierten Gewinne. Dies richtet unsere Interessen an Ihrem Erfolg aus."
        },
        "cancelSubscription": {
          "question": "Kann ich mein Abonnement jederzeit kündigen?",
          "answer": "Ja, Sie können Ihr Abonnement jederzeit herabstufen oder kündigen. Sie behalten den Zugang bis zum Ende Ihres aktuellen Abrechnungszeitraums."
        },
        "supportedExchanges": {
          "question": "Welche Exchanges werden unterstützt?",
          "answer": "Wir unterstützen derzeit große Exchanges einschließlich Binance, Coinbase Pro, Kraken und andere. Überprüfen Sie unsere API-Anmeldedaten-Seite für die vollständige Liste."
        }
      }
    },
    "legal": {
      "documents": "Rechtsdokumente",
      "englishNotice": "Immer in englischer Sprache für rechtliche Klarheit angezeigt",
      "privacy": {
        "title": "Datenschutzrichtlinie",
        "description": "Unsere Datenschutzrichtlinie beschreibt, wie wir Ihre persönlichen Informationen sammeln, verwenden und schützen, wenn Sie DeepTrades Dienste nutzen. Wir sind verpflichtet, die Privatsphäre und Sicherheit Ihrer Daten zu wahren.",
        "highlights": {
          "title": "Wichtige Datenschutz-Highlights:",
          "item1": "Wir sammeln nur notwendige Informationen zur Bereitstellung unserer Dienste",
          "item2": "Ihre Trading-Daten sind verschlüsselt und sicher gespeichert",
          "item3": "Wir verkaufen niemals Ihre persönlichen Informationen an Dritte",
          "item4": "Sie haben Kontrolle über Ihre Daten und Datenschutzeinstellungen"
        },
        "viewFull": "Vollständige Datenschutzrichtlinie anzeigen"
      },
      "terms": {
        "title": "Nutzungsbedingungen",
        "description": "Unsere Nutzungsbedingungen regeln Ihre Nutzung von DeepTrades Plattform und Diensten. Durch die Nutzung unserer Plattform stimmen Sie diesen Bedingungen zu.",
        "highlights": {
          "title": "Wichtige Bedingungen-Highlights:",
          "item1": "Plattform-Nutzungsrechte und -beschränkungen",
          "item2": "Benutzerverantwortlichkeiten und -verpflichtungen",
          "item3": "Service-Verfügbarkeit und -einschränkungen",
          "item4": "Konto-Kündigung und -Sperrungsrichtlinien"
        },
        "viewFull": "Vollständige Nutzungsbedingungen anzeigen"
      },
      "risks": {
        "title": "Risikohinweis"
      }
    },
    "contact": {
      "title": "Support Kontaktieren",
      "form": {
        "name": "Name",
        "email": "E-Mail",
        "subject": "Betreff",
        "message": "Nachricht",
        "sendMessage": "Nachricht Senden",
        "sending": "Senden...",
        "placeholders": {
          "name": "Ihr vollständiger Name",
          "email": "ihre.email@beispiel.com",
          "subject": "Kurze Beschreibung Ihres Problems",
          "message": "Bitte beschreiben Sie Ihr Problem im Detail..."
        }
      },
      "guidelines": {
        "title": "Support-Richtlinien",
        "before": {
          "title": "Vor der Kontaktaufnahme mit dem Support",
          "item1": "Überprüfen Sie zuerst diesen FAQ-Bereich",
          "item2": "Überprüfen Sie Ihre Kontoeinstellungen",
          "item3": "Verifizieren Sie Ihre API-Anmeldedaten",
          "item4": "Überprüfen Sie unsere Status-Seite für bekannte Probleme"
        },
        "when": {
          "title": "Bei der Kontaktaufnahme mit dem Support",
          "item1": "Geben Sie Ihre Konto-E-Mail an",
          "item2": "Beschreiben Sie das Problem im Detail",
          "item3": "Stellen Sie Screenshots bereit, falls zutreffend",
          "item4": "Fügen Sie Fehlermeldungen hinzu"
        },
        "notice": {
          "title": "Wichtiger Hinweis",
          "message": "Wir werden niemals nach Ihren privaten Schlüsseln, Passwörtern oder API-Geheimschlüsseln fragen. Halten Sie diese Informationen sicher und teilen Sie sie niemals mit jemandem."
        }
      },
      "errors": {
        "missingInformation": "Fehlende Informationen",
        "fillAllFields": "Bitte füllen Sie alle Felder aus, bevor Sie absenden.",
        "failedToSend": "Nachricht senden fehlgeschlagen",
        "error": "Fehler",
        "tryAgainLater": "Nachricht senden fehlgeschlagen. Bitte versuchen Sie es später erneut."
      },
      "success": {
        "messageSent": "Nachricht Gesendet!",
        "thankYou": "Vielen Dank, dass Sie uns kontaktiert haben. Wir werden Ihnen innerhalb von 24-48 Stunden antworten."
      }
    }
  },
  "redeemCoupon": {
    "title": "Gutschein Einlösen",
    "subtitle": "Geben Sie Ihren Gutscheincode ein, um Ihre Stufe zu verbessern",
    "currentTier": "Aktuelle Stufe:",
    "couponCode": "Gutscheincode",
    "placeholder": "Gutscheincode eingeben (z.B. DTABC123)",
    "formatHint": "Code muss 4-20 Zeichen haben, nur Buchstaben und Zahlen",
    "redeemButton": "Gutschein Einlösen",
    "redeeming": "Einlösen...",
    "backToTier": "← Zurück zur Stufenverwaltung",
    "tierNames": {
      "starter": "Starter (Kostenlos)",
      "pro": "Pro (Premium)",
      "vip": "VIP (Elite)",
      "unknown": "Unbekannt"
    },
    "howItWorks": {
      "title": "So funktioniert es:",
      "steps": [
        "Geben Sie Ihren Gutscheincode oben ein",
        "Ihre Stufe wird automatisch aktualisiert",
        "Sie erhalten sofortigen Zugang zu neuen Funktionen",
        "Jeder Gutschein kann nur einmal verwendet werden"
      ]
    },
    "errors": {
      "invalidInput": "Ungültige Eingabe",
      "enterCouponCode": "Bitte geben Sie einen Gutscheincode ein",
      "invalidFormat": "Ungültiges Format",
      "formatRequirement": "Gutscheincode muss 4-20 Zeichen haben, nur Buchstaben und Zahlen",
      "redemptionFailed": "Einlösung Fehlgeschlagen",
      "failedToRedeem": "Gutschein konnte nicht eingelöst werden",
      "networkError": "Netzwerkfehler",
      "connectionFailed": "Verbindung zum Server fehlgeschlagen. Bitte versuchen Sie es erneut."
    },
    "success": {
      "redeemed": "Gutschein Erfolgreich Eingelöst!",
      "validFor": "(Gültig für {{days}} Tage)"
    }
  },
  "oauthCallback": {
    "loading": {
      "title": "Authentifizierung...",
      "description": "Bitte warten Sie, während wir Ihre Authentifizierung abschließen."
    },
    "error": {
      "title": "Authentifizierungsfehler",
      "returnToLogin": "Zurück zur Anmeldung",
      "tryAgain": "Erneut versuchen"
    },
    "completing": {
      "title": "Authentifizierung abschließen",
      "description": "Bitte warten Sie, während wir Sie anmelden..."
    },
    "errors": {
      "authenticationFailed": "Authentifizierung fehlgeschlagen",
      "noAuthorizationCode": "Kein Autorisierungscode vom OAuth-Anbieter erhalten",
      "invalidServerResponse": "Ungültige Antwort vom Server",
      "unexpectedError": "Ein unerwarteter Fehler ist während der Authentifizierung aufgetreten",
      "noAdditionalDetails": "Keine zusätzlichen Details verfügbar"
    }
  },
  "resetPassword": {
    "validation": {
      "minLength": "Das Passwort muss mindestens 8 Zeichen lang sein",
      "uppercase": "Das Passwort muss mindestens einen Großbuchstaben enthalten",
      "lowercase": "Das Passwort muss mindestens einen Kleinbuchstaben enthalten",
      "number": "Das Passwort muss mindestens eine Zahl enthalten",
      "specialChar": "Das Passwort muss mindestens ein Sonderzeichen enthalten"
    },
    "errors": {
      "invalidToken": "Ungültiger Token",
      "invalidTokenDescription": "Dieser Passwort-Reset-Link ist ungültig oder abgelaufen.",
      "validationFailed": "Validierung fehlgeschlagen",
      "validationFailedDescription": "Fehler beim Validieren des Reset-Tokens. Bitte versuchen Sie es erneut.",
      "fillAllFields": "Bitte füllen Sie alle Felder aus",
      "passwordsDoNotMatch": "Passwörter stimmen nicht überein",
      "requirementsNotMet": "Passwort-Anforderungen nicht erfüllt",
      "resetFailed": "Passwort-Reset fehlgeschlagen",
      "resetFailedTitle": "Reset fehlgeschlagen"
    },
    "success": {
      "title": "Passwort erfolgreich zurückgesetzt",
      "description": "Ihr Passwort wurde erfolgreich aktualisiert.",
      "passwordUpdated": "✓ Passwort aktualisiert",
      "securityNote": "Sie können sich jetzt mit Ihrem neuen Passwort anmelden. Aus Sicherheitsgründen wurden Sie von allen Geräten abgemeldet.",
      "continueToLogin": "Weiter zur Anmeldung"
    },
    "validating": {
      "title": "Reset-Link wird validiert",
      "description": "Bitte warten Sie, während wir Ihren Passwort-Reset-Link validieren..."
    },
    "invalid": {
      "title": "Ungültiger Reset-Link",
      "description": "Dieser Passwort-Reset-Link ist ungültig oder abgelaufen.",
      "linkInvalid": "Link ungültig",
      "reason1": "• Der Reset-Link ist möglicherweise abgelaufen (Links laufen nach 1 Stunde ab)",
      "reason2": "• Der Link wurde möglicherweise bereits verwendet",
      "reason3": "• Der Link ist möglicherweise fehlerhaft oder unvollständig",
      "requestNewLink": "Neuen Reset-Link anfordern",
      "backToLogin": "Zurück zur Anmeldung"
    },
    "form": {
      "title": "Passwort zurücksetzen",
      "description": "Geben Sie Ihr neues Passwort für {{email}} ein",
      "newPassword": "Neues Passwort",
      "newPasswordPlaceholder": "Geben Sie Ihr neues Passwort ein",
      "confirmPassword": "Neues Passwort bestätigen",
      "confirmPasswordPlaceholder": "Bestätigen Sie Ihr neues Passwort",
      "updating": "Passwort wird aktualisiert...",
      "updateButton": "Passwort aktualisieren",
      "backToLogin": "Zurück zur Anmeldung"
    },
    "requirements": {
      "title": "Passwort-Anforderungen",
      "minLength": "• Mindestens 8 Zeichen lang",
      "caseLetters": "• Groß- und Kleinbuchstaben einschließen",
      "number": "• Mindestens eine Zahl einschließen",
      "specialChar": "• Mindestens ein Sonderzeichen einschließen (!@#$%^&*(),.?\":{}|<>)"
    },
    "expiration": {
      "notice": "Dieser Reset-Link läuft ab am {{time}}"
    }
  },
  "twoFAResetRequest": {
    "securityQuestions": {
      "question1": "Wann war Ihr letzter erfolgreicher Handel?",
      "question2": "Auf welcher Stufe befinden Sie sich derzeit (1, 2 oder 3)?",
      "question3": "Welche Börse nutzen Sie hauptsächlich für den Handel?"
    },
    "errors": {
      "fillRequiredFields": "Bitte füllen Sie alle Pflichtfelder aus (E-Mail, vollständiger Name und Grund)",
      "submitFailed": "Fehler beim Senden der 2FA-Reset-Anfrage",
      "requestFailed": "Anfrage Fehlgeschlagen"
    },
    "success": {
      "requestSubmitted": "Anfrage Gesendet",
      "title": "Anfrage Gesendet",
      "description": "Ihre 2FA-Reset-Anfrage wurde zur Überprüfung eingereicht.",
      "submittedSuccessfully": "✓ Anfrage Erfolgreich Gesendet",
      "email": "E-Mail",
      "requestId": "Anfrage-ID",
      "status": "Status",
      "pendingReview": "Überprüfung Ausstehend",
      "whatHappensNext": "Was passiert als nächstes?",
      "step1": "1. Unser Sicherheitsteam wird Ihre Anfrage und Verifizierungsinformationen überprüfen",
      "step2": "2. Wir können Sie für zusätzliche Verifizierung kontaktieren, falls erforderlich",
      "step3": "3. Sie erhalten eine E-Mail-Benachrichtigung, sobald sie bearbeitet wurde",
      "step4": "4. Bei Genehmigung wird Ihr 2FA deaktiviert und Sie können es erneut einrichten",
      "backToLogin": "Zurück zur Anmeldung",
      "submitAnother": "Weitere Anfrage Senden"
    },
    "form": {
      "title": "2FA-Reset-Anfrage",
      "description": "Zugang zu Ihrem 2FA-Gerät verloren? Füllen Sie dieses Formular aus, um einen Reset von unserem Sicherheitsteam anzufordern.",
      "securityNotice": "⚠️ Wichtiger Sicherheitshinweis",
      "notice1": "• Dieser Prozess erfordert eine manuelle Überprüfung durch unser Sicherheitsteam",
      "notice2": "• Geben Sie so genaue Informationen wie möglich an, um die Verifizierung zu beschleunigen",
      "notice3": "• Falsche Informationen führen zur Ablehnung der Anfrage",
      "notice4": "• Bearbeitungszeit: 1-3 Werktage",
      "requiredInformation": "Erforderliche Informationen",
      "emailAddress": "E-Mail-Adresse *",
      "fullName": "Vollständiger Name *",
      "reason": "Grund für 2FA-Reset *",
      "additionalVerification": "Zusätzliche Verifizierung (Optional aber Empfohlen)",
      "lastLoginDate": "Ungefähres Datum der letzten Anmeldung",
      "accountCreationDate": "Ungefähres Datum der Kontoerstellung",
      "recentActivity": "Aktuelle Kontoaktivität",
      "securityQuestionsTitle": "Sicherheitsfragen",
      "securityQuestionsDescription": "Beantworten Sie diese Fragen, um Ihre Identität zu verifizieren. Lassen Sie es leer, wenn Sie es nicht wissen.",
      "submittingRequest": "Anfrage wird gesendet...",
      "submitButton": "2FA-Reset-Anfrage Senden",
      "backToLogin": "Zurück zur Anmeldung",
      "rememberDevice": "Erinnern Sie sich an Ihr 2FA-Gerät?",
      "tryVerification": "2FA-Verifizierung versuchen",
      "placeholders": {
        "email": "Geben Sie Ihre Konto-E-Mail-Adresse ein",
        "fullName": "Geben Sie Ihren vollständigen Namen wie registriert ein",
        "reason": "Erklären Sie, warum Sie Ihr 2FA zurücksetzen müssen (z.B. verlorenes Telefon, defektes Gerät, etc.)",
        "lastLoginDate": "z.B. 15. Dezember 2024",
        "accountCreationDate": "z.B. November 2024",
        "recentActivity": "Beschreiben Sie aktuelle Aktivitäten (Handel, Stufenänderungen, Zahlungen, etc.)",
        "yourAnswer": "Ihre Antwort"
      }
    }
  },
  "verify2FA": {
    "title": "Zwei-Faktor-Authentifizierung",
    "description": "Ein 6-stelliger Verifizierungscode wurde an Ihre E-Mail-Adresse gesendet",
    "form": {
      "verificationCode": "Verifizierungscode",
      "placeholder": "6-stelligen Code eingeben",
      "verifying": "Verifizierung...",
      "verifyCode": "Code Verifizieren"
    },
    "errors": {
      "sessionExpired": "Sitzung Abgelaufen",
      "pleaseLoginAgain": "Bitte melden Sie sich erneut an.",
      "enterCode": "Bitte geben Sie den Verifizierungscode ein",
      "codeMustBe6Digits": "Verifizierungscode muss 6 Stellen haben",
      "verificationFailed": "Verifizierung fehlgeschlagen",
      "verificationFailedTitle": "Verifizierung Fehlgeschlagen",
      "invalidCode": "Ungültiger Verifizierungscode",
      "failedToResendCode": "Fehler beim erneuten Senden des Codes",
      "failedToResendTitle": "Erneutes Senden Fehlgeschlagen"
    },
    "success": {
      "loginSuccessful": "Anmeldung Erfolgreich",
      "welcomeBack": "Willkommen zurück!",
      "codeSent": "Code Gesendet",
      "codeSentDescription": "Ein neuer Verifizierungscode wurde an Ihre E-Mail gesendet."
    },
    "help": {
      "needHelp": "Hilfe benötigt?",
      "sending": "Wird gesendet...",
      "resendCode": "Code Erneut Senden",
      "backToLogin": "Zurück zur Anmeldung",
      "lostDevice": "2FA-Gerät Verloren? Reset Anfordern",
      "didntReceiveCode": "Code nicht erhalten? Überprüfen Sie Ihren Spam-Ordner oder",
      "resendIt": "erneut senden",
      "byContinuing": "Durch Fortfahren stimmen Sie unseren",
      "termsOfService": "Nutzungsbedingungen",
      "privacyPolicy": "Datenschutzrichtlinie"
    }
  },
  "forgotPassword": {
    "errors": {
      "emailRequired": "E-Mail-Adresse ist erforderlich",
      "sendFailed": "Fehler beim Senden der Passwort-Reset-E-Mail",
      "requestFailed": "Anfrage Fehlgeschlagen"
    },
    "success": {
      "emailSent": "Reset-E-Mail Gesendet",
      "title": "Überprüfen Sie Ihre E-Mail",
      "description": "Falls ein Konto mit dieser E-Mail existiert, erhalten Sie einen Passwort-Reset-Link.",
      "emailSentTitle": "E-Mail Gesendet",
      "emailSentMessage": "Wir haben einen Passwort-Reset-Link an {{email}} gesendet, falls ein Konto existiert.",
      "instruction1": "• Überprüfen Sie Ihren Spam-/Junk-Ordner, falls Sie die E-Mail nicht sehen",
      "instruction2": "• Der Reset-Link läuft in 1 Stunde ab",
      "instruction3": "• Sie können bei Bedarf einen weiteren Reset anfordern",
      "sendAnother": "Weitere Reset-E-Mail Senden",
      "backToLogin": "Zurück zur Anmeldung"
    },
    "form": {
      "title": "Passwort Vergessen",
      "description": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
      "emailAddress": "E-Mail-Adresse",
      "placeholder": "Geben Sie Ihre E-Mail-Adresse ein",
      "sending": "Wird gesendet...",
      "sendResetLink": "Reset-Link Senden",
      "backToLogin": "Zurück zur Anmeldung",
      "noAccount": "Haben Sie kein Konto?",
      "signUp": "Registrieren",
      "lost2FA": "Zugang zu Ihrem 2FA-Gerät verloren?",
      "request2FAReset": "2FA-Reset anfordern"
    },
    "security": {
      "title": "Sicherheitshinweis",
      "note1": "• Passwort-Reset ist nur für traditionelle Konten verfügbar",
      "note2": "• Google OAuth-Nutzer sollten \"Mit Google anmelden\" verwenden",
      "note3": "• Reset-Links laufen nach 1 Stunde aus Sicherheitsgründen ab"
    }
  }
};
